import { LineChartData } from 'shared/ui/Analytics/types';

export type ChartLine = {
  key: string;
  label: string;
};

export const getRenamedLineChartData = (
  data: LineChartData[],
  lines: ChartLine[]
): LineChartData[] => {
  return data.map((item) => {
    const { label, ...rest } = item;
    const renamed: LineChartData = { label };

    lines.forEach(({ key, label: newLabel }) => {
      const value = rest[key];
      if (typeof value === 'string' || typeof value === 'number') {
        renamed[newLabel] = value;
      }
    });

    return renamed;
  });
};
